export default __webpack_public_path__ + "static/media/CV-BPCC.f9e1fb8a.pdf";